module.exports = __webpack_public_path__ + "img/token.d26e96a7.png";